import forResponse from '../utils/forResponse';
import { UPDATE_STREAM_SFW_FLAG } from '../constants/apiUrls/apiUrls';

import http from './http';


export const updateSfwStreamFlag = (payload) => forResponse(http.put(UPDATE_STREAM_SFW_FLAG, payload));
